import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import Link from 'components/UI/Link'
import ROUTES_PATH from 'routes/routePath'
import { AppState } from '../../store'
import { Dispatch } from '../../store/types'
import { bindActionCreators } from 'redux'
import { createAccount } from '../../ducks/auth/operations'
import { connect } from 'react-redux'
import { ConfigurationState } from '../../ducks/references/types'
import { Redirect } from 'react-router-dom'

import {
  fetchConfiguration,
  fetchConfigurationLogo
} from '../../ducks/references/operations'
import LogoTip from '../../components/UI/LogoTip/index.js'

interface State {
  configuration: ConfigurationState
}

class MainPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      configuration: {
        isFetching: false,
        data: {
          appointmentTypeSearchEnabled: false,
          defaultEstimationDropdownType: 'cpt4',
          estimatorHost: '',
          fakeEligibility: true,
          inPatientEnable: true,
          logoEnabled: true,
          outComplexEnable: true,
          outPatientEnable: true,
          physicianFieldEnabled: true,
          procedureCodeEnabled: true,
          serviceAreaFieldEnabled: true
        }
      }
    }
  }
  componentDidMount(): void {
    this.props.fetchConfiguration()
    this.props.fetchConfigurationLogo()
  }

  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (
      prevProps.configuration.data.logoEnabled !==
      this.props.configuration.data.logoEnabled
    ) {
      this.setState({ configuration: { ...this.props.configuration } })
    }
  }

  render() {
    const { configuration } = this.state
    if (!this.props.isAuthenticated) {
       const defaultRoute= process.env.REACT_APP_ENABLE_LOGIN !== undefined ?  ROUTES_PATH.SIGN_IN : ROUTES_PATH.ESTIMATES_START_PAGE;
       return <Redirect to={defaultRoute} />
    }
    return (
      <CenteredBlock>
        {console.log('configuration', configuration.data.logoEnabled)}
        {/*<LogoTip isShowLogo={configuration.data.logoEnabled} />*/}
        <LogoTip />
        <WelcomeWrap>
          <Title>Welcome to the Patient Estimator</Title>
          <Description>Get started by creating an account below.</Description>
          <Buttons>
            <Link variant={'default'} to={ROUTES_PATH.CREATE_ACCOUNT}>
              Create Account
            </Link>
            <Link variant={'secondary'} to={ROUTES_PATH.ESTIMATES_START_PAGE}>
              Create Estimate
            </Link>
            <Link variant={'secondary'} to={ROUTES_PATH.SIGN_IN}>
              Sign In
            </Link>
          </Buttons>
          <Description>
            Estimation provided is not a guarantee of your costs or benefits.
            Your actual costs may vary based on several factors. This is a
            hospital estimate only and does not include any physician charges.
          </Description>
        </WelcomeWrap>
      </CenteredBlock>
    )
  }
}

const mapStateToProps = (state: AppState) => ({
  isAuthenticated: state.auth.isAuthenticated,
  configuration: state.references.configuration
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    { createAccount, fetchConfiguration, fetchConfigurationLogo },
    dispatch
  )

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps & DispatchProps

interface LogoTipProps {
  isShowLogo: boolean
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainPage)
// export default MainPage

const CenteredBlock = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

// const LogoTip = styled.div<LogoTipProps>`
//   background: ${props =>
//     props.isShowLogo ? `url(${logo})` : undefined};//url(${logo});
//   background-size: cover;
//   //background: #fff;
//   width: 144px;
//   height: 144px;
//   margin-bottom: 2.5rem;
// `

const Title = styled.h1`
  font-size: 30px;
  font-weight: 600;
  color: #152735;
  text-align: center;
  padding: 0 1rem;
  margin-bottom: 1.5rem;
`

const Description = styled.p`
  font-size: 1rem;
  color: #585d64;
  text-align: center;
  padding: 0 1rem;
  margin-bottom: 3rem;
`

const WelcomeWrap = styled.div`
  ${media.xs`
    width: 100%;
  `}
  ${media.sm`
    width: 100%;
  `}
  ${media.md`
    width: 380px;
  `}
`

// @ts-ignore
const Buttons = styled.div`
  display: flex;
  flex-direction: column;

  a,
  button {
    margin-bottom: 20px;
  }
`
